export const insertOrUpdateMessage = (prev, messageToAppend) => {
  var _messageToAppend$crea;
  const existingMessageIndex = prev.findIndex(message => message.id === messageToAppend.id || messageToAppend._conversationMessageId && message._conversationMessageId === messageToAppend._conversationMessageId);
  if (existingMessageIndex !== -1) {
    // Update existing message
    const updatedMessages = [...prev];
    updatedMessages[existingMessageIndex] = {
      ...messageToAppend,
      id: updatedMessages[existingMessageIndex].id ?? messageToAppend.id
    };
    return updatedMessages;
  }
  const messageToAppendDate = ('createdDate' in messageToAppend && ((_messageToAppend$crea = messageToAppend.createdDate) == null ? void 0 : _messageToAppend$crea.getTime())) ?? Infinity;
  let insertIndex = prev.findIndex(existingMessage => {
    const existingMessageDate = 'createdDate' in existingMessage && ((existingMessage == null ? void 0 : existingMessage.createdDate) ?? Infinity);
    return existingMessageDate > messageToAppendDate;
  });
  if (insertIndex === -1) {
    insertIndex = prev.length;
  }
  return [...prev.slice(0, insertIndex), messageToAppend, ...prev.slice(insertIndex)];
};
//# sourceMappingURL=insertOrUpdateMessage.js.map